import { sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Field, InjectedFormProps } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import ReactSelectField from 'dashboard/components/FormControls/ReactSelectField';
import { FormAddListItemProps } from 'dashboard/forms/FormAddListItem/FormAddListItem';
import { GOVERNMENT_ID_DISPLAY_STRINGS, GovernmentIdClass } from 'lib/constants/governmentIds';
import { tForGovernmentId } from 'lib/governmentId';
import { isRequired, withMessage } from 'lib/utils/formValidation';

const validate = {
  idClass: [withMessage('Please choose an ID type', isRequired)],
  idNumber: [withMessage('Please enter an ID number', isRequired)],
};

const GovernmentIdNumberFields = ({ submitting }: InjectedFormProps<{}, FormAddListItemProps>) => {
  const { i18n } = useTranslation();

  const sortedGovernmentIdClasses = sortBy(
    Object.keys(GOVERNMENT_ID_DISPLAY_STRINGS) as Array<GovernmentIdClass>,
  );
  const idClassOptions = sortedGovernmentIdClasses.map((idClass) => {
    // eslint-disable-next-line @persona-id/t-string-only
    const idClassName = tForGovernmentId(
      i18n.getFixedT('en-US'),
      ['government-id.title'],
      'US',
      idClass,
    );
    return { label: idClassName, value: idClass };
  });

  return (
    <>
      <Field
        component={ReactSelectField}
        name='idClass'
        id='idClass'
        disabled={submitting}
        validate={validate.idClass}
        options={idClassOptions}
        portal={true}
      />
      <Field
        component={InputField}
        name='idNumber'
        id='idNumber'
        type='text'
        disabled={submitting}
        placeholder='Copy and paste a government identification number here'
        validate={validate.idNumber}
      />
    </>
  );
};

export default GovernmentIdNumberFields;
